<h1>Cancel Enrollment</h1>

<section>
<p>Cancelling your Diagnostic Subscription will prevent your dealership from accessing IDS, FDRS, and Ford DiagNow. By continuing, you acknowledge that your access will be removed, and you will be unable to use your diagnostic software. The ability to Opt In is available if you cancel your subscription in error.
<p><button (click)="cancelSubscription()">Are you Sure?</button>
</section>
